import Cookies from "js-cookie";
import { intl } from "./intl";

export const mapUserIdToMessageId = (id, list) => {
  for (let i = 0; i < list.length; i++) {
    if (list[i].users[0] === id || list[i].users[1] === id) {
      return list[i].id;
    }
  }
  return false;
};

export const addUnreadCount = (userList, messageList, currentUserId) => {
  let unreadCount = 0;
  for (let i = 0; i < userList.length; i++) {
    for (let j = 0; j < messageList.length; j++) {
      userList[i].unreadCount = 0;
    }
  }
  for (let i = 0; i < userList.length; i++) {
    for (let j = 0; j < messageList.length; j++) {
      //const checkUserMessageId = messageList[junread_counter_to === currentUserId ? messageList[j].unread_counter_to : null
      for(let k=0; k<messageList[j].users.length; k++)
      {
        if (messageList[j].unread_counter_to === currentUserId.id && currentUserId.id !== messageList[j].users[k] && messageList[j].users[k] === userList[i].id ) {

          userList[i].unreadCount = messageList[j].unread_counter;
          unreadCount += messageList[j].unread_counter;
        }

      }
    }
  }

  return unreadCount;
};

export const uploadHeader = () => {
  const csrftoken = Cookies.get("csrftoken");

  const userLang = navigator.language || navigator.userLanguage;

  if (csrftoken) {
    return {
      Accept: "application/json",
      "X-CSRFToken": csrftoken,
      "Accept-Language": userLang,
    };
  }
};

export const generateUserTypeDescription = (
  create_questions,
  review_questions
) => {
  if (create_questions && review_questions) {
    return intl.formatMessage({
      defaultMessage: "Can create and review questions",
      id: "componentUserTypesDescription1",
    });
  } else if (create_questions) {
    return intl.formatMessage({
      defaultMessage: "Can create questions",
      id: "componentUserTypesDescription2",
    });
  } else if (review_questions) {
    return intl.formatMessage({
      defaultMessage: "Can review questions",
      id: "componentUserTypesDescription3",
    });
  }
};

export const approvedStyle = (status) => {
  switch (status) {
    case 10:
      return "circle-pending";
    case 20:
      return "circle-approved";
    case 30:
      return "circle-rejected";
    default:
      return "circle-pending";
  }
};
export const approvedText = (status) => {
  switch (status) {
    case 10:
      return "Pending";
    case 20:
      return "Approved";
    case 30:
      return "Rejected";
    default:
      return "Pending";
  }
};

export const buildQueryStr = (obj) => {
  let str = "&";
  for (const [key, value] of Object.entries(obj)) {
    if (value && !value.startsWith("_")) {
      str += `${key}=${value}&`;
    }
  }
  return str.slice(0, str.length - 1);
};

export const numToSSColumn = (num) => {
  var s = "",
    t;

  while (num > 0) {
    t = (num - 1) % 26;
    s = String.fromCharCode(65 + t) + s;
    num = ((num - t) / 26) | 0;
  }
  return s || undefined;
};

export const setLocalStorage = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value));
};

export const removeLocalStorage = (key) => {
  localStorage.removeItem(key);
};

export const objectToArray = (object) => {
  const array = []
  Object.keys(object).map((item) => {
    array.push({ 'id': item, 'value':  typeof object[item] === 'object' ? objectToArray(object[item]) : object[item]})
  })
  return array;
}
export const arrayToObject = (arr) => {
  return arr.reduce((obj, item) => {
    obj[arr.indexOf(item)] = item
    return obj
  }, {})
}

export const alphabetArray = ["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z"];
